export enum EventType {
	globalSearchChange = 'ksys-global-search-change',	// Used when a search is fired from the Global Search app
	globalInputsChange = 'ksys-global-inputs-change',	// Used when the input values change on a Global Inputs app
	appInitialized = 'ksys-app-initialized',			// Used when an app is initialized
}